export const RECALL_TYPE_FAST = 1;
export const RECALL_TYPE_PRECISE = 2;

export const getDefaultAgenticRagConfig = () => ({
  agent_knowledge_type: 1,
  chat_model_name: '',
  is_reasoning: true,
  is_use_ref: true,
  max_context_num: 5,
  max_turn: 5,
  prompt: '',
  recall_type: RECALL_TYPE_PRECISE,
  rerank_model_name: ''
});

export const ensureAgenticRagConfig = botInfo => {
  const defaults = getDefaultAgenticRagConfig();
  const raw = botInfo?.agentic_rag_config;
  if (!raw || typeof raw !== 'object') {
    botInfo.agentic_rag_config = { ...defaults };
    return botInfo.agentic_rag_config;
  }
  botInfo.agentic_rag_config = {
    ...defaults,
    ...raw,
    recall_type:
      Number(raw.recall_type) === RECALL_TYPE_FAST
        ? RECALL_TYPE_FAST
        : RECALL_TYPE_PRECISE
  };
  return botInfo.agentic_rag_config;
};
